import { Button, Form, Popconfirm, theme } from 'antd';
import { FC } from 'react';
import { ExclamationCircle } from 'react-bootstrap-icons';

import { AppFormProps } from '@/common/interfaces';
import { defineInputStatus } from '@/common/utils';

import { SiteSearchConsoleFormFields, SiteSearchConsoleFormInputs } from '@/modules/Domains';
import { SearchConsoleAccountsAllAutocomplete } from '@/modules/DomainsApi';

interface Props extends AppFormProps<typeof SiteSearchConsoleFormInputs, SiteSearchConsoleFormFields> {
  isButtonsDisabled: boolean;
  formSearchConsoleAccountId: string | undefined;
  handleClearErrors: () => void;
  handleView: () => void;
}

export const SearchConsoleAccountSiteSettingForm: FC<Props> = ({
  form,
  formErrors,
  formName,
  initialValues,
  isFormLoading,
  isButtonsDisabled,
  validationSchema,
  formSearchConsoleAccountId,
  handleView,
  handleClearErrors,
  handleFinish,
  handleFinishFailed
}) => {
  const { colorError } = theme.useToken().token;

  const confirm = () => form.submit();

  return (
    <Form
      form={ form }
      name={ formName }
      initialValues={ initialValues }
      disabled={ isFormLoading }
      autoComplete="off"
      onFinish={ handleFinish }
      onFinishFailed={ handleFinishFailed }
      layout="horizontal"
      style={{ width: '100%', display: 'flex', alignItems: 'flex-start', gap: 8 }}
    >
      <Form.Item
        style={{ width: '80%', margin: 0 }}
        hasFeedback
        name={ SiteSearchConsoleFormInputs.SearchConsoleAccountId }
        help={ formErrors?.searchConsoleAccountId }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.searchConsoleAccountId) }
        rules={ validationSchema.searchConsoleAccountId }
      >
        <SearchConsoleAccountsAllAutocomplete size="small" disabled={ isButtonsDisabled } onChange={ handleClearErrors }/>
      </Form.Item>

      <Form.Item noStyle>
        <Popconfirm
          disabled={ isButtonsDisabled }
          okType="danger"
          okText="Так"
          icon={ <ExclamationCircle color={ colorError }/> }
          title="Змінити акаунт Seacrh Console?"
          onConfirm={ confirm }
          onCancel={ handleView }
          placement="topLeft"
        >
          <Button
            style={{ width: '20%', margin: 0, marginTop: 4 }}
            disabled={ isButtonsDisabled }
            loading={ isButtonsDisabled }
            size="small"
            onClick={ formSearchConsoleAccountId === initialValues.searchConsoleAccountId || !formSearchConsoleAccountId ? handleView : undefined }
          >
            OK
          </Button>
        </Popconfirm>
      </Form.Item>
    </Form>
  );
};
